import { CloudinaryApiService } from './apiService';

export const uploadService = async (path, postData) => CloudinaryApiService.post(`${path}`, postData)
  .then((res) => res)
  .catch((err) => ({
    data: null,
    error: err.response.data.error.message,
  }));
